import * as APITypes from "~/API";
import { getUnitPlanList } from "~/services/server/unitPlan/getUnitPlanList";
import { buildPropertyMap } from "../helpers";
import type { EntityListData, EntityListOptions } from "~/types";

export const formatUnitPlanOptions = (
  unitPlanList: APITypes.UnitPlan[],
  propertyMap: Record<string, APITypes.Property>,
): EntityListOptions[] => {
  return unitPlanList.map((plan) => {
    const property = propertyMap[plan.propertyID];
    return {
      value: plan.id,
      text: `Unit plan: ${plan.name} - Property: ${property?.name || "Unknown"}`,
    };
  });
};

export const getUnitPlanEntityList = async (
  ownerID: string,
  ownerType: APITypes.OwnerType,
): Promise<EntityListData> => {
  const unitPlanList = await getUnitPlanList({ ownerID, ownerType });
  const propertyMap = await buildPropertyMap(ownerID, ownerType);

  return {
    propertyList: [],
    buildingList: [],
    unitList: [],
    serviceRequestList: [],
    amenityList: [],
    unitPlanList: unitPlanList.data,
    propertyMap,
    buildingMap: {},
    unitMap: {},
  };
};
